// extracted by css-extract-rspack-plugin
export default {"bar":"NFC8n","icon":"iidAg","icon_exit":"LYOyA","iconExit":"LYOyA"};